import { MessageTypes } from '../../constants/messageConst.js'
import { ruleResult, ruleResultMessage } from './pipelineResult.js'
import { runClaimantComparePipeline } from './runClaimantComparePipeline.js'

let claimHasPolicy = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {
            let { policyDetails } = objectInstance
            if (policyDetails && policyDetails.resellerId > 0 /*&& policyDetails.productId > 0*/) {
                return ruleResult(1, 'claimHasPolicy', true, null)
            }
        }

        return ruleResult(1, 'claimHasPolicy', false, ruleResultMessage(MessageTypes.MSG_ERROR, 'No policy!'))
    }
}

let claimHasWebUser = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance && objectInstance.userId != null) {
            return ruleResult(2, 'claimHasWebUser', true, null)
        }

        return ruleResult(2, 'claimHasWebUser', false, ruleResultMessage(MessageTypes.MSG_ERROR, 'No web user!'))

    }
}

let claimNotApproved = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {
            let { approved } = objectInstance
            if (!approved) {
                return ruleResult(4, 'claimNotApproved', true, null)
            }
        }

        return ruleResult(4, 'claimNotApproved', false, ruleResultMessage(MessageTypes.MSG_ERROR, 'The claim has already been approved'))
    }
}

let claimNotDeclined = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {
            let { declined } = objectInstance
            if (!declined) {
                return ruleResult(4, 'claimNotDeclined', true, null)
            }
        }

        return ruleResult(4, 'claimNotDeclined', false, ruleResultMessage(MessageTypes.MSG_ERROR, 'The claim has already been declined'))
    }
}

let claimGadgetModelSet = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {
            let { gadgetDetails } = objectInstance
            if (gadgetDetails && gadgetDetails.length > 0) {

                for (let i = 0; i < gadgetDetails.length; i++) {
                    let { modelId } = gadgetDetails[i]

                    if (modelId == 0) {
                        return ruleResult(5, 'claimGadgetModelSet', false, ruleResultMessage(MessageTypes.MSG_WARNING, 'At least one of the gadgets has a model id of 0!'))
                    }
                }
            }
        }

        return ruleResult(5, 'claimGadgetModelSet', true, null)
    }
}

let claimGadgetMakeSet = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {
            let { gadgetDetails } = objectInstance
            if (gadgetDetails && gadgetDetails.length > 0) {

                for (let i = 0; i < gadgetDetails.length; i++) {
                    let { makeId } = gadgetDetails[i]

                    if (makeId == 0) {
                        return ruleResult(5, 'claimGadgetMakeSet', false, ruleResultMessage(MessageTypes.MSG_WARNING, 'At least one of the gadgets has a make id of 0!'))
                    }
                }
            }
        }

        return ruleResult(5, 'claimGadgetMakeSet', true, null)
    }
}

let claimDocumentUploaded = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {
            let { documentDetails } = objectInstance
            if (!documentDetails || (documentDetails && documentDetails.length == 0)) {
                return ruleResult(6, 'claimDocumentUploaded', false, ruleResultMessage(MessageTypes.MSG_WARNING, 'No supporting documents have been uploaded!'))
            }
        }

        return ruleResult(6, 'claimDocumentUploaded', true, null)
    }
}

let claimIncidentWithinCoverDates = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {

            let between = (start, end, check) => {
                if (check && start && end) {
                    return (check >= start && check <= end)
                }
            }

            let betweenWithBuffer = (start, end, check, buffer) => {
                if (check && start && end) {
                    let endWithBuffer = new Date(end);
                    endWithBuffer.setDate(endWithBuffer.getDate() + buffer);

                    return (check >= start && check <= endWithBuffer);
                }
            }

            let { insuranceLineId, incidentDetails, policyDetails } = objectInstance

            if (policyDetails && policyDetails.deserialisedObject) {
                let { incidentDate } = incidentDetails
                incidentDate = new Date(incidentDate)
                switch (insuranceLineId) {
                    case 1: {
                        let { gadgetDetails: claimGadgets } = objectInstance
                        let { gadgets: policyGadgets } = policyDetails.deserialisedObject
                        for (var gadget of claimGadgets) {
                            let policyGadget = policyGadgets.find(g => g.itemGUID == gadget.itemGuid)
                            if (policyGadget) {
                                let { coverStartDate, coverEndDate } = policyGadget
                                coverStartDate = new Date(coverStartDate)
                                coverEndDate = new Date(coverEndDate)

                                coverStartDate.setHours(0, 0, 0, 0)
                                coverEndDate.setHours(23, 59, 59, 0)

                                if (!between(coverStartDate, coverEndDate, incidentDate)) {
                                    return ruleResult(10,
                                        'claimIncidentWithinCoverDates',
                                        false,
                                        ruleResultMessage(MessageTypes.MSG_ERROR,
                                            `At least one of the gadgets claimed for was not covered on date of incident: [${incidentDate}], cover dates: [${coverStartDate} - ${coverEndDate}]`))
                                }
                            } else {
                                return ruleResult(10,
                                    'claimIncidentWithinCoverDates',
                                    false,
                                    ruleResultMessage(MessageTypes.MSG_ERROR,
                                        `At least one of the gadgets could not be found on the policy!`))
                            }
                        }
                        break;
                    }
                    case 2: {
                        let { travelCoverStartDate, travelCoverEndDate } = policyDetails.deserialisedObject
                        travelCoverStartDate = new Date(travelCoverStartDate)
                        travelCoverEndDate = new Date(travelCoverEndDate)

                        travelCoverStartDate.setHours(0, 0, 0, 0)
                        travelCoverEndDate.setHours(23, 59, 59, 0)

                        if (!between(travelCoverStartDate, travelCoverEndDate, incidentDate)) {
                            return ruleResult(10,
                                'claimIncidentWithinCoverDates',
                                false,
                                ruleResultMessage(MessageTypes.MSG_ERROR,
                                    `Incident date [${incidentDate}] is not within cover dates [${travelCoverStartDate} - ${travelCoverEndDate}]`))
                        }
                        break;
                    }
                    default:

                }
            } else {
                    return ruleResult(10, 
                        'claimIncidentWithinCoverDates', 
                        false,
                        ruleResultMessage(MessageTypes.MSG_ERROR,
                            `Cannot determine cover dates because no policy information available!`))
            }
            //if (!(incidentDate > coverStartDate && incidentDate < coverEndDate)) {
            //    return ruleResult(10, 
            //        'claimIncidentWithinCoverDates', 
            //        false,
            //        ruleResultMessage(MessageTypes.MSG_ERROR,
            //            `Incident date [${incidentDate}] is not within cover dates [${coverStartDate} - -${coverEndDate}]`))
            //}            
        }
        return ruleResult(10, 'claimIncidentWithinCoverDates', true, null)
    }
}

let claimRelatedReferenceSet = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {
            let { relatedReference } = objectInstance
            if (!relatedReference  || (relatedReference && relatedReference.length == 0)) {
                return ruleResult(7, 'claimRelatedReferenceSet', false, ruleResultMessage(MessageTypes.MSG_WARNING, 'Related reference has not been set!'))
            }
        }

        return ruleResult(7, 'claimRelatedReferenceSet', true, null)
    }
}

let claimAllValidationPipelinesPassed = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {
            let { pipelineRunHistoryDetails } = objectInstance
            if (pipelineRunHistoryDetails && pipelineRunHistoryDetails.length > 0) {

                for (let i = 0; i < pipelineRunHistoryDetails.length; i++) {
                    let { passed } = pipelineRunHistoryDetails[i]

                    if (passed == false) {
                        return ruleResult(8, 'claimAllValidationPipelinesPassed', false, ruleResultMessage(MessageTypes.MSG_WARNING, 'At least one of the validation pipelines failed!'))
                    }
                }

                return ruleResult(8, 'claimAllValidationPipelinesPassed', true, null)
            }
        }        
    }
}

let claimValidationPipelineRun = (context) => {
    if (context) {
        let { objectInstance } = context
        if (objectInstance) {
            let { pipelineRunHistoryDetails } = objectInstance
            if (pipelineRunHistoryDetails && pipelineRunHistoryDetails.length > 0) {
                return ruleResult(8, 'claimValidationPipelineRun', true, null)
            } else {
                return ruleResult(8, 'claimValidationPipelineRun', false, ruleResultMessage(MessageTypes.MSG_WARNING, 'No validation pipelines were run for this claim!'))
            }
        }
    }
}

let claimPolicyholderClaimantMatch = (context) => {
    if (context) {
        let { objectInstance } = context

        let pipelineResult = runClaimantComparePipeline(objectInstance)
        if (pipelineResult && pipelineResult.ruleResults) {
            let failures = pipelineResult.ruleResults.filter(r => r.message != null)
            if (failures && failures.length > 0) {
                return ruleResult(9, 'claimPolicyholderClaimantMatch', false, ruleResultMessage(MessageTypes.MSG_WARNING, 'Claimant and Policyholder details do not match!'))
            }
        }

        return ruleResult(9, 'claimPolicyholderClaimantMatch', true, null)
    }
}

export {
    claimHasPolicy,
    claimHasWebUser,
    claimNotApproved,
    claimNotDeclined,
    claimGadgetModelSet,
    claimGadgetMakeSet,
    claimDocumentUploaded,
    claimRelatedReferenceSet,
    claimAllValidationPipelinesPassed,
    claimValidationPipelineRun,
    claimPolicyholderClaimantMatch,
    claimIncidentWithinCoverDates
}